export default "__VITE_ASSET__DEYdFcXC__"